import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function FashionSection() {
  const fashionArticles = articles.filter(
    (a) => a.categorySlug === "fashion"
  ).slice(0, 3);

  return (
    <section className="py-16 bg-background-100">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              时尚造型
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">佐佐木希最新时尚资讯与穿搭灵感</p>
          </div>
          <Link
            to="/category/fashion"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {fashionArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group rounded-lg border border-background-200/70 hover:border-background-300 overflow-hidden bg-background-50 transition-all duration-300 ${
                index === 0 ? "lg:col-span-2" : ""
              }`}
            >
              <div className={`flex flex-col ${index === 0 ? "lg:flex-row" : ""}`}>
                <div
                  className={`overflow-hidden ${
                    index === 0
                      ? "lg:w-1/2 aspect-[16/10] lg:aspect-auto"
                      : "aspect-[16/10]"
                  }`}
                >
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={article.title}
                  />
                </div>
                <div className={`p-5 flex flex-col justify-center ${index === 0 ? "lg:w-1/2" : ""}`}>
                  <span className="px-2.5 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-medium w-fit mb-3 whitespace-nowrap">
                    {article.category}
                  </span>
                  <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}